<template>
  <printBase ref="LinkQR029" :title='title' :id='id' :page='page' :width='1024'>
    <div v-for="(pageList, pageIndex) in printInfoList" :key="pageIndex" :slot="page==1? 'content' : `content${pageIndex+1}`" class="printLinkQR">
      <div class="printTitle">{{printInfo.storeName}}商品退货单</div>
      <table style="width: 100%; color:black" class="minTitle" border='0' cellspacing="0">
        <tr>
          <td style="width: 60%">退货单位：{{printInfo.storeName}}</td>
          <td style="width: 40%">退货单号：{{printInfo.code}}</td>
        </tr>
        <tr>
          <td style="width: 60%">供应商编码：{{printInfo.supplierCode}}</td>
          <td style="width: 40%">退货日期：{{printInfo.refundTime}}</td>
        </tr>
        <tr>
          <td style="width: 60%">供应商名称：{{printInfo.supplierName}}</td>
          <td style="width: 40%">采购员：{{printInfo.purchaserNames}}</td>
        </tr>
      </table>
      <table style="width: 100% ;color: black;" class='printContent' border='1' cellspacing="0">
        <tr>
          <th style="width: 70px;">商品编码</th>
          <th style="width: 126px;">商品通用名/规格</th>
          <th style="width: 112px;">生产企业</th>
          <!-- <th style="width: 64px;">产地</th> -->
          <th style="width: 60px;">剂型</th>
          <th style="width: 40px;">单位</th>
          <th style="width: 40px;">数量</th>
          <th style="width: 68px;">退货单价</th>
          <th style="width: 68px;">退货总额</th>
          <th style="width: 70px;">生产批号</th>
          <th style="width: 65px;">是否DTP</th>
          <th style="width: 65px;">进项税率</th>
          <th style="width: 70px;">不含税金额</th>
          <!-- <th style="width: 86px;">生产日期</th> -->
          <th style="width: 82px;">有效期</th>
          <!-- <th style="width: 110px;">批准文号</th> -->
          <th style="width: 40px;">质量状况</th>
        </tr>
        <tbody>
            <tr v-for="(item, printIndex) in pageList" :key="printIndex">
            <td><span>{{item.purchaseRefundDetail.serialCode}}</span></td>
            <td><span>{{item.medicineInfoVo.approvedDrugNames}}/{{item.medicineInfoVo.specifications}}</span></td>
            <td><span>{{item.medicineInfoVo.manufacturer}}</span></td>
            <!-- <td><span>{{item.medicineInfoVo.countryOfOrigin}}</span></td> -->
            <td><span>{{item.medicineInfoVo.dosageFormString}}</span></td>
            <td><span>{{item.medicineInfoVo.drugMinimumPackagingUnitString}}</span></td>
            <td><span>{{item.purchaseRefundDetail.num}}</span></td>
            <td><span>{{item.purchaseRefundDetail.refundPrice}}</span></td>
            <td><span>{{item.purchaseRefundDetail.amount}}</span></td>
            <td><span>{{item.purchaseRefundDetail.batchCode}}</span></td>
            <td><span>{{item.isDtpStr}}</span></td>
            <td><span>{{item.purchaseRefundDetail.inputTaxRate}}</span></td>
            <td><span>{{item.purchaseRefundDetail.refundTotalPriceAfterTax}}</span></td>
            <!-- <span><span>{{item.prodDate}}</span></td> -->
            <td><span>{{item.expiryDate}}</span></td>
            <!-- <td><span>{{item.medicineInfoVo.approvalCode}}</span></td> -->
            <td><span></span></td>
          </tr>
        </tbody>
      </table>
        <div style=" color:black">
          <span>合计金额：{{printInfo.refundTotalAmountChineseString}}</span>
          <span style="margin-left:100px;">小写：{{printInfo.refundTotalAmountDisplay}}</span>
          <span style="margin-left:100px;">不含税金额：{{printInfo.refundTotalAmountAfterTaxDisplay}}</span>
          <span style="margin-left:100px;">税额：{{printInfo.refundTotalTaxAmountDisplay}}</span>
          <span style="margin-left:100px;">本页小计：{{printInfo.refundTotalAmountDisplay}}</span>
          <span style="float: right">{{pageIndex+1}}/{{page}}</span>
        </div>
        <div style=" color:black">本单一式三联：（财务凭证、结算、存货单位）</div>

    </div>
  </printBase>
</template>
<script>
import _ from 'lodash';
import printBase from './printBase';
import refund from '../../services/refund';
import utils from '../../libs/utils';

export default {
  data() {
    return {
      title: 'Link-QR-029',
      id: 'LinkQR029',
      printInfoList: [{}],
      printInfo: {},
      page: 1,
      pageSize: 5, // 一页展示5条记录
    };
  },
  components: {
    printBase,
  },
  methods: {
    // splitDateString(target, rank) {
    //   let tempTarget = utils.deepClone(target);
    //   tempTarget = utils.exchangeTime(tempTarget).split('');
    //   tempTarget.splice(rank, 0, ' ');
    //   tempTarget = tempTarget.join('');
    //   return tempTarget;
    // },
    handlePrint(purchaseRefundId, pageSize) {
      this.pageSize = pageSize;
      refund.purchaseRefundPrint({ purchaseRefundId }).then((res) => {
        if (res.data.status === 200) {
          const {
            allOriginTotalAmountChineseString, allOriginTotalAmount, purchaseRefund, purchaseRefundDetailVoList, purchaserNames, refundTime, refundTotalAmountChineseString, refundTotalAmountDisplay, refundTotalTaxAmountDisplay, refundTotalAmountAfterTaxDisplay,
          } = res.data.data;
          this.printInfoList = [];
          this.printInfo = {
            storeName: purchaseRefund.storeName,
            id: purchaseRefund.id,
            code: purchaseRefund.code,
            supplierCode: purchaseRefund.supplierCode,
            supplierName: purchaseRefund.supplierName,
            refundTime: utils.exchangeTime(refundTime),
            purchaserNames,
            allOriginTotalAmountChineseString,
            allOriginTotalAmount,
            refundTotalAmountChineseString,
            refundTotalAmountDisplay,
            refundTotalTaxAmountDisplay,
            refundTotalAmountAfterTaxDisplay,
          };

          this.printInfo.amountWithoutTax = purchaseRefundDetailVoList.map(item => item.amountWithoutTax).reduce((pre, cur) => utils.fixNumber(pre + cur, 2));
          this.printInfo.tax = utils.fixNumber(allOriginTotalAmount - this.printInfo.amountWithoutTax, 2);
          this.printInfoList = _.chunk(purchaseRefundDetailVoList, this.pageSize);
          this.printInfoList.forEach((item) => {
            let sum = 0;
            item.forEach((element) => {
              sum += element.purchaseRefundDetail.originAmount * 1000000;
              element.prodDate = utils.formatTime(element.prodDate, 'YYYY/MM/DD');
              element.expiryDate = utils.formatTime(element.expiryDate, 'YYYY/MM/DD');
              element.purchaseRefundDetail.refundTotalPriceAfterTax = utils.fixNumber(element.purchaseRefundDetail.refundTotalPriceAfterTax, 2);
            });
            console.log(item.pageSum);
            item.pageSum = sum / 1000000;
          });
          console.log(this.printInfoList);
          this.page = this.printInfoList.length;
          this.$nextTick(() => {
            this.$refs.LinkQR029.handlePrint();
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.printContent td,th{
    text-align: center;
    position: relative;
    border-color: #000;
    font-weight: 400;
    word-break: break-all;
    padding: 2px 6px;
    font-size: 12px;
    *{
      display: inline-block;
      max-height: 32px;
      overflow:hidden
    }

  }
</style>
